import styled from "styled-components";
// 메인 화면 섹션 머리말: 영문 eyebrow + 제목 + 설명, 오른쪽에 '전체 보기' 같은 링크(more)
const SectionHead = ({ eyebrow, title, desc, more, inverted }) => (
  <Div $inverted={inverted}>
    <div>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2>{title}</h2>
      {desc && <p>{desc}</p>}
    </div>
    {more && <div className="more">{more}</div>}
  </Div>
);
export default SectionHead;
const Div = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 1rem 2rem;
  margin-bottom: 1.75rem;
  & .eyebrow {
    display: block;
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: ${({ $inverted, theme }) => ($inverted ? theme.colors.foreground.highlightinverted : theme.colors.accent)};
    margin-bottom: 0.6rem;
  }
  & h2 {
    margin: 0;
    font-size: clamp(1.75rem, 3vw, 2.4rem);
    line-height: 1.25;
    font-weight: 800;
    letter-spacing: -0.03em;
    color: ${({ $inverted, theme }) => ($inverted ? "white" : theme.colors.dark)};
  }
  & p {
    margin: 0.6rem 0 0;
    font-size: 1.05rem;
    color: ${({ $inverted, theme }) => ($inverted ? "rgba(255, 255, 255, 0.75)" : theme.colors.foreground.dimmed)};
  }
  & .more > a {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    font-weight: 600;
    font-size: 0.95rem;
    color: ${({ $inverted, theme }) => ($inverted ? "white" : theme.colors.dark)};
    white-space: nowrap;
    &:hover {
      color: ${({ $inverted, theme }) => ($inverted ? theme.colors.foreground.highlightinverted : theme.colors.accent)};
    }
  }
`;
